import { formatGetHeaders } from '@configurations/api-configuration';
import { SourceGateway } from '@scenario/gateways/source.gateway';
import { Source } from '@scenario/models/source.model';
import { environment } from '../../../../../environments/environment';

export class ApiSourceGateway implements SourceGateway {
  private readonly sourceApi = `${environment.backend_url}/api/v1/source`;

  async retrieveAll(): Promise<Source[]> {
    try {
      const response = await fetch(`${this.sourceApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving sources: ' + error);
    }
  }
}
